export function getDataURLForImage(file) {
    return new Promise(resolve => {
        const reader = new FileReader();
        // Event is very basic interface, it does not not have `result` property.
        // TypeScript (v2.5.3) does not come with a `FileLoadEvent`
        reader.addEventListener('load', (e) => {
            resolve({
                result: e.target.result,
                id: file.name
            });
        });
        reader.readAsDataURL(file);
    });
}
export function getArrayBufferForImage(file) {
    return new Promise(resolve => {
        const reader = new FileReader();
        // Event is very basic interface, it does not not have `result` property.
        // TypeScript (v2.5.3) does not come with a `FileLoadEvent`
        reader.addEventListener('load', (e) => {
            resolve({
                result: e.target.result,
                id: file.name
            });
        });
        reader.readAsArrayBuffer(file);
    });
}
export const ONE_KB = 1024;
export const ONE_MB = ONE_KB * 1024;
export function getFileSize(file) {
    const { size } = file;
    if (size >= ONE_MB) {
        return `${(size / ONE_MB).toFixed(1)}MB`;
    }
    if (size >= ONE_KB) {
        return `${(size / ONE_KB).toFixed(1)}KB`;
    }
    return `${size}B`;
}
